import { loadTheme } from '@uifabric/styling/lib/styles';
import { IPalette } from 'office-ui-fabric-react/lib/Styling';

export namespace Palettes {
    const whiteFabricPalette: Partial<IPalette> = {

        themePrimary: '#0078d4',
        themeLighterAlt: '#eff6fc',
        themeLighter: '#deecf9',
        themeLight: '#c7e0f4',
        themeTertiary: '#71afe5',
        themeSecondary: '#2b88d8',
        themeDarkAlt: '#106ebe',
        themeDark: '#005a9e',
        themeDarker: '#004578',
        neutralLighterAlt: '#faf9f8',
        neutralLighter: '#f3f2f1',
        neutralLight: '#edebe9',
        neutralQuaternaryAlt: '#e1dfdd',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c6c4',
        neutralTertiary: '#a19f9d',
        neutralSecondary: '#605e5c',
        neutralPrimaryAlt: '#3b3a39',
        neutralPrimary: '#323130',
        neutralDark: '#201f1e',
        black: '#000000',
        white: '#ffffff',
    };

    const blackFabricPalette: Partial<IPalette> = {
        themePrimary: '#0078d4',
        themeLighterAlt: '#eff6fc',
        themeLighter: '#deecf9',
        themeLight: '#c7e0f4',
        themeTertiary: '#71afe5',
        themeSecondary: '#2b88d8',
        themeDarkAlt: '#106ebe',
        themeDark: '#005a9e',
        themeDarker: '#004578',
        neutralLighterAlt: '#303030',
        neutralLighter: '#383838',
        neutralLight: '#464646',
        neutralQuaternaryAlt: '#4e4e4e',
        neutralQuaternary: '#555555',
        neutralTertiaryAlt: '#727272',
        neutralTertiary: '#c8c8c8',
        neutralSecondary: '#d0d0d0',
        neutralPrimaryAlt: '#dadada',
        neutralPrimary: '#ffffff',
        neutralDark: '#f4f4f4',
        black: '#f8f8f8',
        white: '#262626'
    };

    export enum PaletteType {
        LIGHT,
        DARK
    };

    export function saveSelectedPalette(palette: PaletteType) {
        localStorage.setItem('plugin_ui_palette', palette.toString());

        loadTheme({
            palette: getPalette(palette)
        });
    }

    /**
     * This function loads the previously stored palette value and loads the corresponding theme
     */
    export function restoreSelectedPalette(): void {
        const palette = getPalette();
        loadTheme({ palette });
    }


    export function loadSelectedPalette(): PaletteType {
        const palette = localStorage.getItem('plugin_ui_palette');

        if (palette) {
            const paletteType: PaletteType = parseInt(palette);
            return (paletteType !== undefined && paletteType !== null) ? paletteType : PaletteType.LIGHT;
        }

        return PaletteType.LIGHT;
    }

    export function getPalette(paletteType?: PaletteType) {
        if (!paletteType) {
            paletteType = loadSelectedPalette();
        }

        switch (paletteType) {
            case PaletteType.LIGHT:
            default:
                return whiteFabricPalette;

            case PaletteType.DARK:
                return blackFabricPalette;
        }
    }
}